module.exports = __webpack_public_path__ + "static/media/mall road map without text.46d25c7a.jpg";